import { createActionGroup, props } from '@ngrx/store';

import { SsoOidcConfig } from '../../models/sso.model';

export const AuthSsoActions = createActionGroup({
  source: 'SSO',
  events: {
    'Check Email': props<{ email: string }>(),
    'Check Email Success': props<{ config: SsoOidcConfig }>(),
    'Check Email Failure': props<{ error: string }>(),
    'Exchange Code': props<{ code: string }>(),
    'Exchange Code Failure': props<{ error: string }>(),
  },
});
